import { initInteractionCountPolyfill } from '../interactionCountPolyfill';
import { DEFAULT_DURATION_THRESHOLD, estimateP98LongestInteraction, processInteractionEntry, resetInteractions } from '../interactions';
import { po } from './po';
/**
 * Creates `event` performance observer to implement reporting of interaction to next paint.
 * Also reports `lcp`, `cls`, `tbt`, `tbt5s`, `tbt10s`, and `tbtFinal` as a side effect
 *
 * @param {function} reportFn - Report callback for collection of statistics
 * @param {object} - metrics - Shared metrics to coordinate between performance observers
 * @returns {function} - disconnect function
 */
// eslint-disable-next-line import/prefer-default-export
export function initInteractionToNextPaint(reportFn, metrics) {
  let timeout5s;
  let timeout10s;
  let isDisconnected = false;
  initInteractionCountPolyfill();
  const handleEventEntries = performanceEntries => {
    // Update index of interaction entries
    performanceEntries.forEach(processInteractionEntry);

    // Find longest interaction and report
    const inp = estimateP98LongestInteraction();
    if (inp) {
      reportFn('inp', inp.latency);
    }
  };
  const handleFirstInput = () => {
    // Disconnect this observer since callback is only triggered once
    fiObserver.disconnect();

    // Report `lcp` at first input
    // We also listen for `keydown` and `click` events in `./largest-contentful-paint.js`
    // so between both events we should report LCP at first input
    reportFn('lcp', metrics.lcp);

    // Report `cls` at first input
    reportFn('cls', metrics.cls);

    // Report `tbt` at first input
    reportFn('tbt', metrics.tbt);

    // TBT with 5 second delay after FID
    timeout5s = setTimeout(() => {
      reportFn('tbt5S', metrics.tbt);
    }, 5000);

    // TBT with 10 second delay after FID
    timeout10s = setTimeout(() => {
      reportFn('tbt10S', metrics.tbt);
    }, 10000);
  };
  const inpObserver = po('event', handleEventEntries, {
    durationThreshold: DEFAULT_DURATION_THRESHOLD
  });
  const fiObserver = po('first-input', handleFirstInput);

  // Return function to disconnect performance observers and clear any running timers
  return () => {
    if (!isDisconnected) {
      // Report final `tbt` time
      reportFn('tbtFinal', metrics.tbt);

      // Clear timeouts, if outstanding
      clearTimeout(timeout5s);
      clearTimeout(timeout10s);
      resetInteractions();

      // `fiObserver` can be `false` if no browser support for observer type
      fiObserver && fiObserver.disconnect();

      // `inpObserver` can be `false` if no browser support for observer type
      inpObserver && inpObserver.disconnect();

      // only need to execute this handler once
      isDisconnected = true;
    }
  };
}
//# sourceMappingURL=interaction-to-next-paint.js.map